import { PencilRuler, FileCheck2, HardHat, Hammer, Leaf, Armchair, Store } from "lucide-react";
import Reveal from "./Reveal";

const SERVICES = [
  {
    icon: PencilRuler,
    title: "Architekt & projekt",
    text: "Jsme s vámi od první skici. Navrhneme dům i interiér tak, aby dával smysl vám — ne katalogu.",
    span: "md:col-span-7",
  },
  {
    icon: FileCheck2,
    title: "Inženýring & povolení",
    text: "Vyřídíme stavební povolení a veškerou agendu. Vy se věnujete životu, ne úřadům.",
    span: "md:col-span-5",
  },
  {
    icon: HardHat,
    title: "Precizní stavba",
    text: "Váš nový dům na klíč za 90 dnů. Stavíme na nejvyšší energetické třídy A/B.",
    span: "md:col-span-5",
  },
  {
    icon: Hammer,
    title: "Rekonstrukce & bytová jádra",
    text: "Kompletní rekonstrukce domů a bytů. Bytové jádro zvládneme za 7 dnů.",
    span: "md:col-span-7",
  },
  {
    icon: Leaf,
    title: "Dotace Nová zelená úsporám",
    text: "Pomůžeme získat dotace a nastavit technologie pro špičkový akustický a tepelný komfort.",
    span: "md:col-span-6",
  },
  {
    icon: Armchair,
    title: "Zabydlení na klíč",
    text: "Od hrubé stavby až po finální zabydlení. Předáváme klíče, ne problémy.",
    span: "md:col-span-6",
  },
  {
    icon: Store,
    title: "Komerční fit-outy — Nanu-Nana, Sinsay, Ugo salaterie",
    text: "Stavíme obchody a gastro provozy v nákupních centrech. Šibeniční termíny otevření nás naučily maximální preciznosti a disciplíně — a tu samou spolehlivost přinášíme i na vaši stavbu nebo rekonstrukci.",
    span: "md:col-span-12",
  },
];

export default function Services() {
  return (
    <section id="sluzby" data-testid="services-section" className="py-24 lg:py-32 bg-coal/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70 mb-4">
            Služby od A do Z
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-zinc-100 max-w-2xl leading-tight">
            Od architekta <span className="gold-text">po zabydlení</span>
          </h2>
          <p className="mt-5 max-w-2xl text-zinc-400 leading-relaxed">
            Jsme s klientem od první skici, přes vyřízení povolení a stavbu až po finální
            zabydlení. Komplexní služba jako od velké firmy — za férové ceny a s osobním
            přístupem prověřených živnostníků.
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08} className={s.span}>
              <div
                data-testid={`service-card-${i}`}
                className="group h-full bg-card2 border border-white/5 hover:border-gold/30 rounded-xl p-7 transition-colors duration-500"
              >
                <div className="w-11 h-11 rounded-lg bg-gold/10 border border-gold/25 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-black transition-colors duration-500">
                  <s.icon size={20} />
                </div>
                <h3 className="mt-5 font-display text-2xl text-zinc-100">{s.title}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
